import { Component, signal } from '@angular/core';
import { AuthService, BlockAbstractComponent, ParserService } from '@gallaghercp/core-frontend';

@Component({
    selector: 'core-block-content-selection',
    templateUrl: './block-content-selection.component.html',
    styles: [
        `
            .content-selection {
                &__label {
                    display: block;
                    span {
                        display: block;
                        font-weight: bold;
                        margin-bottom: 0.5rem;
                    }
                }
                &__description {
                    margin-top: 0.5rem;
                }
            }
        `,
    ],
    standalone: false,
})
export class BlockContentSelectionComponent extends BlockAbstractComponent {
    public selectedItemIndex = signal<number>(0);

    constructor(
        protected override parser: ParserService,
        protected override auth: AuthService,
    ) {
        super(parser, auth);
    }

    onSelectionChange(event: Event) {
        const selectElement = event.target as HTMLSelectElement;
        this.selectedItemIndex.set(parseInt(selectElement.value, 10));
    }
}
